export const selectedCountry = {
  placeholder: "Sélectionnez un pays",
};
